import { S } from './state.js';

export const DEXP = [
  { id: 'food', label: 'מזון', icon: '🛒', color: '#e8a87c', type: 'expense' },
  { id: 'housing', label: 'דיור', icon: '🏠', color: '#6fcf97', type: 'expense' },
  { id: 'transport', label: 'תחבורה', icon: '🚗', color: '#56ccf2', type: 'expense' },
  { id: 'health', label: 'בריאות', icon: '💊', color: '#eb5757', type: 'expense' },
  { id: 'edu', label: 'חינוך', icon: '📚', color: '#9b51e0', type: 'expense' },
  { id: 'fun', label: 'בילויים', icon: '🎉', color: '#f2994a', type: 'expense' },
  { id: 'clothes', label: 'ביגוד', icon: '👗', color: '#27ae60', type: 'expense' },
  { id: 'other', label: 'אחר', icon: '📦', color: '#bdbdbd', type: 'expense' },
];
export const DINC = [
  { id: 'salary', label: 'משכורת', icon: '💼', color: '#6fcf97', type: 'income' },
  { id: 'bonus', label: 'בונוס', icon: '⭐', color: '#f2c94c', type: 'income' },
  { id: 'rent_in', label: 'שכירות', icon: '🏢', color: '#56ccf2', type: 'income' },
  { id: 'other_in', label: 'אחר', icon: '💰', color: '#bdbdbd', type: 'income' },
];
export const COLORS = ['#c8603a', '#3a7c5e', '#3a6c9e', '#7c5cbf', '#d4a843', '#b84040', '#2d9596', '#e07b39'];
const FALLBACK = { id: 'other', icon: '📦', label: 'אחר', color: '#bdbdbd' };

export function cats(type) {
  return (type === 'income' ? DINC : DEXP).concat(S.cats.filter((c) => c.type === type));
}
export function cat(type, id) {
  return cats(type).find((c) => c.id === id) || FALLBACK;
}
